import { FieldType, UUID } from '@indigohive/cogfy-types'
import { FieldPropertyMention, FieldPropertyMentionValue } from '../../FieldPropertyMention'
import { Input } from '../../Input'
import { Select } from '../../Select'
import { ChatMiddlewareConditionSource, ChatMiddlewareConditionValue } from '../ChatMiddlewareConditionForm'
import { GetFieldPropertiesResult } from '@indigohive/cogfy-types/endpoints/getFieldProperties'

export type ChatMiddlewareConditionValueInputProps = {
  source: ChatMiddlewareConditionSource
  value: ChatMiddlewareConditionValue
  fields?: { id: UUID, name: string, type: FieldType }[]
  fieldProperties?: GetFieldPropertiesResult
  onChange: (value: ChatMiddlewareConditionValue) => void
}

export function ChatMiddlewareConditionValueInput (props: ChatMiddlewareConditionValueInputProps) {
  const { source, value, fields = [], fieldProperties, onChange } = props

  return (
    <>
      {source.type === 'content_type' && (
        <Select
          size="md"
          value={value as string}
          onChange={event => { onChange(event.target.value) }}
          options={[
            { value: 'audio', label: 'Audio' },
            { value: 'contacts', label: 'Contacts' },
            { value: 'document', label: 'Document' },
            { value: 'image', label: 'Image' },
            { value: 'interactive', label: 'Interactive' },
            { value: 'location', label: 'Location' },
            { value: 'reaction', label: 'Reaction' },
            { value: 'sticker', label: 'Sticker' },
            { value: 'text', label: 'Text' },
            { value: 'video', label: 'Video' }
          ]}
        />
      )}

      {source.type === 'content' && (
        <FieldPropertyMention
          fields={fields}
          fieldProperties={fieldProperties}
          value={{
            // Maitain backward compatibility
            strings: typeof value === 'string' ? [value] : (value as FieldPropertyMentionValue | undefined)?.strings ?? [],
            args: (value as FieldPropertyMentionValue | undefined)?.args ?? []
          }}
          onChange={value => { onChange(value) }}
        />
      )}

      {source.type === 'template' && (
        <>
          {source.field.type === 'boolean' && (
            <Select
              size="sm"
              value={(value as FieldPropertyMentionValue | undefined)?.strings?.[0] ?? ''}
              onChange={event => onChange({
                strings: event.target.value === '' ? [] : [event.target.value],
                args: []
              })}
              options={[
                { value: '', label: '-' },
                { value: 'true', label: 'True' },
                { value: 'false', label: 'False' }
              ]}
            />
          )}
          {source.field.type !== 'boolean' && (
            (
              <FieldPropertyMention
                fields={fields}
                fieldProperties={fieldProperties}
                value={{
                  strings: (value as FieldPropertyMentionValue | undefined)?.strings ?? [],
                  args: (value as FieldPropertyMentionValue | undefined)?.args ?? []
                }}
                onChange={value => { onChange(value) }}
              />
            )
          )}
        </>
      )}

      {/* Maitain backward compatibility */}
      {source.type === 'field' && (
        <>
          {source.field.type === 'boolean' && (
            <Select
              size="md"
              value={value as string}
              onChange={event => {
                onChange(event.target.value === ''
                  ? null
                  : event.target.value === 'true')
              }}
              options={[
                { value: '', label: '-' },
                { value: 'true', label: 'True' },
                { value: 'false', label: 'False' }
              ]}
            />
          )}
          {source.field.type !== 'boolean' && (
            <Input
              size="sm"
              value={value as string}
              onChange={event => { onChange(event.target.value) }}
            />
          )}
        </>
      )}
    </>
  )
}
